module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('gmap-map', {
    staticStyle: {
      "width": "100%",
      "height": "100%"
    },
    attrs: {
      "center": _vm.center,
      "zoom": 17
    }
  }, _vm._l((_vm.markers), function(m) {
    return _c('gmap-marker', {
      attrs: {
        "position": m.position,
        "clickable": true,
        "draggable": true
      },
      on: {
        "click": function($event) {
          _vm.center = m.position
        }
      }
    })
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2bc14bb3!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Maps.vue
// module id = 536
// module chunks = 83